export default {
    navItems: { sections: [] },
    user: {},
    groups: { userGroups: [], pendingGroups: [], userGroupsInitialised: false },
    notifications: {
        items: [],
        lastViewed: localStorage.getItem('notificationsViewOn') != null ? new Date(localStorage.getItem('notificationsViewOn')) : null,
        lastLoaded: null,
        latestNotification: null
    },
    events: [],
    followers: {},
    following: {},
    users: {},
    routes: {
        searchResults: {},
        myRoutesResults: {},
        bookmarksResults: {},
    },
    route: {},
    auth: {
        isFetching: false,
        isAuthenticated: localStorage.getItem('isAuthenticated') === 'true' ? true : false,
        message: null,
        userId: localStorage.getItem('uId'),
    },
    allowCookies: localStorage.getItem('allowCookies') === 'true' ? true : false, 
    apiCallsInProgress: 0,
    settings: {},
    routeMapSearchState: {},
    routeSearchCriteria: {},
    userNetworkSearchCriteria: {},
    routeCreatorState: { createMode: "draw", plotMode: "auto", reCentreOnLoad: false, autoMode: "bike" },
    draftRoute: [],
    timeline: {},
    groupInvitation: {}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/initialState.js